import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable no-console */
import { API_ENDPOINTS } from "./endpoints"; // Function to load the Chili Piper script

var loadChiliPiperScript = function loadChiliPiperScript() {
  if (window.ChiliPiper) {
    return Promise.resolve();
  }

  return new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.src = API_ENDPOINTS.CHILI_PIPER_API_URL;
    script.crossOrigin = "anonymous";
    script.type = "text/javascript";
    script.onload = resolve;

    script.onerror = function () {
      return reject(new Error("Failed to load Chili Piper Concierge script"));
    };

    document.head.appendChild(script);
  });
};
/**
 * Sends form data to Chili Piper and handles response
 * @param {Object} response - Response with action and location
 * @param {FormData} formData - Form data to send
 * @param {string} chiliPiperRouterId - Chili Piper router ID
 */


export var sendFormDataToChiliPiper = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, formData, chiliPiperRouterId) {
    var lead, redirect, hideChiliPiperIframes, timeoutId, timeoutDuration, clearChiliPiperTimeout, handleBookingEvent, handleCallback;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return loadChiliPiperScript();

          case 3:
            _context.next = 9;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            console.error("Chili Piper integration failed:", _context.t0);
            return _context.abrupt("return");

          case 9:
            if (window.ChiliPiper) {
              _context.next = 12;
              break;
            }

            console.error("ChiliPiper is not available after script load");
            return _context.abrupt("return");

          case 12:
            // Convert FormData to lead object
            lead = Object.fromEntries(Array.from(formData.entries()).filter(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  value = _ref3[1];

              return typeof value === "string";
            })); // Redirection function

            redirect = function redirect() {
              if (response.action === "redirect") {
                window.location.assign(response.location);
              }
            }; // Hide Chili Piper iframes


            hideChiliPiperIframes = function hideChiliPiperIframes() {
              document.querySelectorAll("div>iframe.chilipiper-frame").forEach(function (iframe) {
                iframe.style.display = "none";
                iframe.parentElement.style.position = "inherit";
              });
            }; // Timeout management


            timeoutId = null;
            timeoutDuration = API_ENDPOINTS.TIMEOUT_DURATION;

            clearChiliPiperTimeout = function clearChiliPiperTimeout() {
              if (timeoutId !== null) {
                clearTimeout(timeoutId);
                timeoutId = null;
              }
            }; // Booking confirmation handler


            handleBookingEvent = function handleBookingEvent(_ref4) {
              var data = _ref4.data;

              if (_typeof(data) === "object" && Object.keys(data)[0] === "booking-confirmed") {
                clearChiliPiperTimeout();
                redirect();
                window.removeEventListener("message", handleBookingEvent);
              }
            }; // Add event listener


            window.addEventListener("message", handleBookingEvent, false); // Common callback handler

            handleCallback = function handleCallback() {
              clearChiliPiperTimeout();
              redirect();
              hideChiliPiperIframes();
              window.removeEventListener("message", handleBookingEvent);
            }; // Submit to Chili Piper


            window.ChiliPiper.submit(API_ENDPOINTS.CHILI_PIPER_TENANT_ID, chiliPiperRouterId, {
              map: true,
              lead: lead,
              onSuccess: function onSuccess() {// Empty handler - handleBookingEvent will handle booking confirmation via the message event
              },
              onError: function onError() {
                return handleCallback();
              },
              onClose: function onClose() {
                return handleCallback();
              },
              onDisqualified: function onDisqualified() {
                return handleCallback();
              },
              onRouted: function onRouted() {
                timeoutId = setTimeout(function () {
                  timeoutId = null;
                  handleCallback();
                  window.removeEventListener("message", handleBookingEvent);
                }, timeoutDuration);
              }
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function sendFormDataToChiliPiper(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();